export const queryKeys = {
  DIRECTION_BY_NAME: 'direction_by_name'
};

export const universityIdsWithTests = new Set<number>([
  159, 158, 151, 141, 184, 145, 147, 149, 157, 153, 152, 155, 190
]);
